import React from 'react';

const GradientActionTrigger = () => {
  return (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17 4H32C33.6569 4 35 5.34315 35 7V28C35 29.6569 33.6569 31 32 31H22.6219C22.4436 31.6929 22.205 32.3615 21.9119 33H32C34.7614 33 37 30.7614 37 28V7C37 4.23858 34.7614 2 32 2H17C14.2386 2 12 4.23858 12 7V16.0411C12.6846 16.0975 13.3528 16.2115 14 16.3781V7C14 5.34315 15.3431 4 17 4ZM11 36C15.4183 36 19 32.4183 19 28C19 23.5817 15.4183 20 11 20C6.58172 20 3 23.5817 3 28C3 32.4183 6.58172 36 11 36ZM11 38C16.5228 38 21 33.5228 21 28C21 22.4772 16.5228 18 11 18C5.47715 18 1 22.4772 1 28C1 33.5228 5.47715 38 11 38ZM12 24V27H15V29H12V32H10V29H7V27H10V24H12Z"
        fill="url(#paint0_linear)"
      />
      <defs>
        <linearGradient id="paint0_linear" x1="1" y1="20" x2="37" y2="20" gradientUnits="userSpaceOnUse">
          <stop stopColor="#BB7C8F" />
          <stop offset="0.264056" stopColor="#8672D3" />
          <stop offset="0.515625" stopColor="#686AF9" />
          <stop offset="0.772651" stopColor="#5740FA" />
          <stop offset="1" stopColor="#4611F8" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default GradientActionTrigger;
